import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Modal, Header, Icon } from "semantic-ui-react";

export default class SpecialCollectionDeleteModal extends Component {
  state = { modalOpen: false };

  handleOpen = () => this.setState({ modalOpen: true });
  handleClose = () => this.setState({ modalOpen: false });

  handleDelete = () => {
    const { specialCollection, deleteSpecialCollection } = this.props;

    if (deleteSpecialCollection) {
      deleteSpecialCollection(specialCollection.metadata.pid);
    }
    this.handleClose();
  };

  render() {
    const { specialCollection } = this.props;
    const { modalOpen } = this.state;

    if (!specialCollection || !specialCollection.metadata) {
      return null;
    }

    return (
      <Modal
        trigger={
          <Button
            fluid
            negative
            icon="trash"
            labelPosition="left"
            content="Delete Collection"
            onClick={this.handleOpen}
            style={{ textAlign: "right", marginRight: "25px" }}
          />
        }
        open={modalOpen}
        onClose={this.handleClose}
        size="small"
      >
        <Header icon="trash" content="Delete Special Collection" />
        <Modal.Content>
          <p>
            Are you sure you want to delete the special collection
            <strong> "{specialCollection.metadata.title}"</strong>?
          </p>
          <p>This action cannot be undone.</p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.handleClose}>
            <Icon name="remove" /> Cancel
          </Button>
          <Button color="red" onClick={this.handleDelete}>
            <Icon name="checkmark" /> Delete
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

SpecialCollectionDeleteModal.propTypes = {
  specialCollection: PropTypes.object.isRequired,
  // relations: PropTypes.object,
  deleteSpecialCollection: PropTypes.func,
};

SpecialCollectionDeleteModal.defaultProps = {
  // relations: {},
  deleteSpecialCollection: null,
};
